export default {"src":"/_next/static/media/delete.e85eedfc.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};